// components/Modal/DiagnosticModal.tsx
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DiagnosticWizard from "../DiagnosticWizard/DiagnosticWizard";
import "./DiagnosticModal.scss";

interface DiagnosticModalProps {
  onClose: () => void;
  isOpen: boolean;
}

const DiagnosticModal: React.FC<DiagnosticModalProps> = ({ onClose, isOpen }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Small delay to ensure proper animation
    if (isOpen) {
      const timer = setTimeout(() => setIsVisible(true), 50);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    // Wait for animation to complete before closing
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleComplete = (result: any) => {
    console.log("Diagnostic completed:", result);
    // You can add logic here to handle the diagnostic result
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="diagnostic-modal">
        {/* Backdrop */}
        <motion.div
          className="modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: isVisible ? 1 : 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={handleClose}
        />

        {/* Modal Content */}
        <motion.div
          className="modal-content"
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{
            opacity: isVisible ? 1 : 0,
            scale: isVisible ? 1 : 0.9,
            y: isVisible ? 0 : 20
          }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{
            duration: 0.3,
            type: "spring",
            damping: 25,
            stiffness: 300
          }}
        >
          <div className="modal-header">
            <h2></h2>
            <button
              className="modal-close-btn"
              onClick={handleClose}
              aria-label="Fermer"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div className="modal-body">
            <DiagnosticWizard onComplete={handleComplete} />
          </div>

          <div className="modal-footer">
            <p className="modal-note">
              Ce diagnostic vous aide à identifier vos risques et à choisir l'offre de protection adaptée.
              Aucune donnée n'est sauvegardée.
            </p>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default DiagnosticModal;